import React from "react";
import { FormContextProps } from "./Form.props";

/**
 * @deprecated
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FormContext = React.createContext<FormContextProps<any>>({} as FormContextProps<any>);

/**
 * @deprecated
 */
export const FormContextProvider = FormContext.Provider;

/**
 * @deprecated
 */
export { Controller, useWatch, useFieldArray } from "react-hook-form";
